module.exports = __webpack_public_path__ + "img/history-four.15056021.png";